<template>
  <main class="science">
    <!-- Banner -->
    <section class="banner banner--howitworks">
      <div class="container">

        <div class="inner align--top">
          <div class="item">
            <div class="nav__links" :class="{'sticky': isSticky}">
              <h1>{{ how.header.title }}</h1>
              <scrollactive ref="scrollactive" active-class="sticky-active" :alwaysTrack="false" :offset="80" :clickToScroll="true">
                <ul class="nav__offer">
                  
                  <router-link :to="'/'" exact tag="li">
                    <a class="nav__backMenu"><img src="../assets/logo-simple.svg" alt=""></a>
                  </router-link>

                  <router-link v-for="(item, index) in how.subnav" :key="index" :to="item.link" tag="li">
                    <a class="scrollactive-item">{{ item.name }}</a>
                  </router-link>

                </ul>
              </scrollactive>
            </div>
          </div>
          
        </div>
        
      </div>
      <div class="mask"></div>
    </section>
    <section class="banner banner--form">
      <div class="container">
          <!-- Value fit -->
          <h2 id="value-fit"> {{ how.section.Valuefit.title }} </h2>
          <p v-html="how.section.Valuefit.p1"></p>
          <p v-html="how.section.Valuefit.p2"></p>
          <!-- Trucking -->
          <h2 id="trucking-industry"> {{ how.section.Trucking.title }} </h2>
          <p v-html="how.section.Trucking.p1"></p>
          <p v-html="how.section.Trucking.p2"></p>
          <p v-html="how.section.Trucking.p3"></p>
          <p v-html="how.section.Trucking.p4"></p>
      </div>
      <div class="container">
        
          <div class="form">
            
            <!-- Form request components -->
            <form-request 
              :originForm="section"
              :ctaLabel="home.formRequestPaper.cta">
            </form-request>
          
        </div>
      </div>
            <div class="container">

          <!-- Cases -->
           <h2 id="cases"> {{ how.section.Case.title }} </h2>
          <p v-html="how.section.Case.p1"></p>
          <p v-html="how.section.Case.p2"></p>
          <p v-html="how.section.Case.p3"></p>
          <p v-html="how.section.Case.p4"></p>
        </div>
        <div class="container">
        
          <div class="form">
            
            <!-- Form request components -->
            <form-request 
              :originForm="section"
              :ctaLabel="home.formRequestDemo.cta">
            </form-request>
          
        </div>
</div>
      <div class="mask"></div>
    </section>
   
  </main>
</template>

<script>
import Home from '@/contents/homepage.json'
import How from '@/contents/how.json'
import Usps from '@/components/Usps.vue'
import FormRequest from '@/components/Form.vue'
export default {
  components: {
    Usps,
    FormRequest
  },
  name: 'How',
  props: ['mobile'],
  data () {
    return {
      section: this.$options.name,
      how: How,
      home: Home,
      isSticky: false,
      ticking: false,
      lastPositionScroll: 0
    }
  },
  methods: {
    setStickyClass (positionScroll) {
      let elm = document.querySelector('.banner--model')
      let heightElm = elm.clientHeight
      if (positionScroll >= heightElm) {
        this.isSticky = true
      } else {
        this.isSticky = false
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', (e) => {
      this.lastPositionScroll = window.scrollY
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.setStickyClass(this.lastPositionScroll)
          this.ticking = false
        })
      }
      this.ticking = true
    })
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/howitworks.vue